<template>
	<div class="xs-12 p4">
		<!-- Buttons -->
		<div class="flex mt1">
			<j-button
				v-if="hasDiscountLogic"
				type="tertiary"
				@click="form.codeOrWithoutCode = 'withoutCode'"
				>{{ $t("manually") }}</j-button
			>
			<j-button
				:class="hasDiscountLogic ? 'ml8' : 'ml0'"
				type="tertiary"
				@click="form.codeOrWithoutCode = 'code'"
				>{{ $t("discount_code") }}</j-button
			>
		</div>

		<!--Discount code -->
		<core-form-input
			class="mt6"
			v-if="form.codeOrWithoutCode === 'code'"
			componentName="j-base-input-text"
			name="code"
			:label="$t('discount_code')"
			v-validate="'required'"
			v-model="form.code"
			:validationErrors="errors"
			@enter="handleSave"
		/>

		<!-- Ad hoc discount without discount code -->
		<div v-else class="flex wrap mt6">
			<!-- Name -->
			<div class="xs-12 mb4">
				<!-- When nameOptions are passed, display it as select box -->
				<core-form-input
					v-if="nameOptions && nameOptions.length"
					componentName="j-base-select"
					name="name"
					:label="$t('name')"
					:options="nameOptions"
					v-model="form.name"
				/>
				<!-- When no nameOptions, display it as input text -->
				<core-form-input
					v-else
					componentName="j-base-input-text"
					name="name"
					:label="$t('name')"
					v-model="form.name"
				/>
			</div>

			<div class="xs-4">
				<core-form-input
					componentName="j-base-radios"
					name="flatOrRatio"
					:label="$t('select')"
					v-model="form.flatOrRatio"
					:options="[
						{ name: $t('percentage'), value: 'ratio' },
						{ name: $t('flat'), value: 'flat' }
					]"
				/>
			</div>

			<!-- Flat -->
			<div v-if="form.flatOrRatio === 'flat'" class="flex xs-8">
				<core-form-input
					componentName="j-base-input-number"
					name="discountFlat"
					:label="$t('flat')"
					v-model="form.discountFlat"
				/>
			</div>

			<!-- Ratio -->
			<div v-else class="xs-8 wrap flex">
				<div class="xs-11">
					<core-form-input
						componentName="j-base-input-number"
						name="discountPercentage"
						:label="$t('percentage')"
						v-model="form.discountPercentage"
					/>
				</div>
				<div class="flex xs-bottom xs-center xs-1 pb4">%</div>
			</div>

			<!-- Order -->
			<div class="xs-12 mt4">
				<core-form-input
					componentName="j-base-input-number"
					name="order"
					:label="$t('order')"
					v-model="form.order"
				/>
			</div>
		</div>

		<div class="flex xs-between mt6">
			<j-button :isLoading="isLoading" @click="handleSave">{{
				$t("save")
			}}</j-button>
			<j-button @click="handleCancel" type="bordered">{{
				$t("cancel")
			}}</j-button>
		</div>
	</div>
</template>

<script>
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
// import api from "@/api/gql.js"
// import { gql } from "@/api/utils.js"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	props: {
		pricing: {
			type: Object
		},
		addDiscountWithoutCode: {
			type: Function
		},
		addDiscountWithCode: {
			type: Function
		},
		hasDiscountLogic: {
			type: Boolean,
			default: false
		},

		/**
		 * When nameOptions are passed, we use it to show a select box for name
		 * Otherwise we show input text box
		 */
		nameOptions: {
			type: Array,
			default: () => []
		}
	},

	data() {
		return {
			form: {
				codeOrWithoutCode: this.hasDiscountLogic ? "withoutCode" : "code", // or code
				code: null,
				flatOrRatio: "ratio", // or flat
				discountFlat: 0,
				discountPercentage: 0,
				order: 0,
				name: ""
			},

			isLoading: false
		}
	},

	methods: {
		handleSave() {
			if (this.form.codeOrWithoutCode === "withoutCode")
				this.handleAddDiscountWithoutCode()
			else this.handleAddDiscountWithCode()
		},

		async handleAddDiscountWithCode() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			// Check if code has been applied before
			if (
				this.pricing.appliedDiscounts?.some(
					discount => discount.code === this.form.code
				)
			) {
				this.$store.dispatch("showError", [
					"This code has already been applied"
				])
				return
			}

			this.isLoading = true
			await this.addDiscountWithCode(this.form.code)
			this.isLoading = false
		},

		async handleAddDiscountWithoutCode() {
			let calculationJsonLogic
			if (this.form.flatOrRatio === "flat")
				calculationJsonLogic = `{ "-": [ {"var" : "premium"}, ${this.form.discountFlat} ]}`

			// Ratio jsonLogic
			if (this.form.flatOrRatio === "ratio")
				calculationJsonLogic = `{ "*": [ {"var" : "premium"}, ${(100 -
					this.form.discountPercentage) /
					100} ]}`

			this.isLoading = true
			await this.addDiscountWithoutCode({
				calculationJsonLogic,
				order: this.form.order,
				name: this.form.name
			})
			this.isLoading = false
		},

		handleCancel() {
			this.$emit("cancelled")
		}
	}
}
</script>
